module.exports = __webpack_public_path__ + "resources/images/schrift-ddebd941af3a198ca0aeb5d336f7cc23-cache.jpg";